export class EvaluateActiveIndexFromUrl {
  static readonly type = '[Wizard Nav] Update active index from URL';
  constructor(public url: string) {}
}

export class SetActiveStepConfirmation {
  static readonly type = '[Wizard Nav] Update ACTIVE Wizard Step Confirmation';
  constructor(public isConfirmed: boolean) {}
}

export class SetSkipBillingStep {
  static readonly type = '[Wizard Nav] Update Skip Billing Step';
  constructor(public skipBilling: boolean) {}
}

export class ResetOrderWizardNavigation {
  static readonly type = '[Wizard Nav] Reset Order Wizard UI State';
  constructor() {}
}
